import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupResizeObserverErrorHandler } from './utils/resizeObserverErrorHandler';

// 立即设置ResizeObserver错误处理
(() => {
  const errorHandler = (e: Event) => {
    const errorEvent = e as ErrorEvent;
    if (errorEvent.message && errorEvent.message.includes('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.stopPropagation(); 
      e.preventDefault();
      return false;
    }
  };
  window.addEventListener('error', errorHandler, true);
  
  // 重写console.error
  const originalConsoleError = console.error;
  console.error = (...args: any[]) => {
    if (args.some(arg => typeof arg === 'string' && arg.includes('ResizeObserver'))) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
})();

// 在应用启动前设置完整的错误处理
setupResizeObserverErrorHandler();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
